<template>
    <g clip-path="url(#clip0_4514_26908)">
        <path
            d="M14.875 2.8335V4.25016H14.1667L10.625 9.56266V15.5835H6.375V9.56266L2.83333 4.25016H2.125V2.8335H14.875ZM4.53617 4.25016L7.79167 9.13341V14.1668H9.20833V9.13341L12.4638 4.25016H4.53617Z" />
    </g>

</template>
